import { Spinner } from '../../../components/ui/spinner'

export default function Loading() {
  return (
    <div className="my-12 flex items-end justify-center gap-2 text-xl font-medium text-primary">
      <Spinner /> Carregando...
    </div>
  )
}
